import React from 'react';
import PropTypes from 'prop-types';

import flow from 'lodash/flow';

import {
  Button,
  ButtonRow,
  Callout,
  FormLayout,
  Heading,
  HorizontalRule,
  IconChevronLeftThick,
  Link,
  ListItem,
  Paragraph,
  Section,
  UnorderedList,
  withTrackPage,
} from '@piggybank/core';

import {
  Form,
} from '@piggybank/form';

import DiCreditInformationPanel from '~/components/DiCreditInformationPanel';

import { getHeaderKey, NLS, setPageTitle } from './payrollReviewDiFunctions';

import { withAppContext } from '~/AppContext';

import styles from './payroll-review-di.module.css';

const PayrollReviewDi = ({ data, onContinue }) => {
  let heading = NLS`${getHeaderKey(data.displayData.globalData.offerId)}`;
  return (
    <FormLayout>
      <Section>
        <Heading level={1}>{heading}</Heading>
        <HorizontalRule />
      </Section>
      <Form initialValues={{ loanAmountIndex: 1 }} onSubmit={setPageTitle(heading)}>
        {({ values }) => (
          <div>
            <Section>
              <DiCreditInformationPanel />
            </Section>

            <Section>
              <Heading accentBar level={2}>
                {NLS`Terms and Conditions`}
              </Heading>

              <Callout type="information">
                <Paragraph marginBottom={0}>
                  {NLS`Important information`}
                </Paragraph>
              </Callout>

              <UnorderedList>
                <ListItem>
                  {`${NLS`Check requirements, terms, contract conditions and commissions in`} `}<Link href={'https://www.hsbc.com.mx/creditos/personales/'}>www.hsbc.com.mx/creditos/personales</Link>
                </ListItem>
                <ListItem>{NLS`CONDUSEF RECA Registration Numbers`}</ListItem>
                <ListItem>{NLS`I authorize periodic charges to be made to my account under the concept of direct debit for the payment of this credit.`}</ListItem>
              </UnorderedList>

              <HorizontalRule hiddenOnSmallViewport />

              <nav className={styles.navigation}>
                <ButtonRow>
                  <Button id={data.displayData.globalData.offerId} onClick={() => onContinue(values)}>{NLS`Accept`}</Button>
                </ButtonRow>
                <Link
                  buttonPadding
                  disabled={false}
                  elementType="button"
                  hoverUnderline
                  iconSlotLeft={<IconChevronLeftThick inline />}
                  onClick={() => { history.back(); }}
                  type="button"
                >
                  <span>{NLS`Back`}</span>
                </Link>
              </nav>
            </Section>
          </div>
        )}
      </Form>
    </FormLayout>
  );};

PayrollReviewDi.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      globalData: PropTypes.shape({
        offerId: PropTypes.string,
      }),
    }),
  }),
  onContinue: PropTypes.func,
};

export default flow(
  withAppContext(),
  withTrackPage('loanReview', 'component')
)(PayrollReviewDi);
